<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
<p class="OT" id="_idParaDest-3"><a id="_idTextAnchor002"></a><a href="#/Reid_Wisdoms_Feast3#toc2">Abbreviations</a></p>
<p class="AB"><em class="italic">Ant.</em>	Josephus, <em class="italic">Jewish Antiquities</em></p>
<p class="AB"><em class="italic">BAR</em> <em class="italic">Biblical Archaeology Review</em></p>
<p class="AB">BDAG	<em class="italic">A Greek-­English Lexicon of the New Testament and Other Early Christian Literature. </em>3d ed. Revised and edited by Frederick William Danker. Chicago: University of Chicago Press, 2000</p>
<p class="AB">BJS	Brown Judaic Studies</p>
<p class="AB"><em class="italic">BTB</em> <em class="italic">Biblical Theology Bulletin</em></p>
<p class="AB"><em class="italic">CBQ</em> <em class="italic">Catholic Biblical Quarterly</em></p>
<p class="AB">CCEL	Christian Classics Ethereal Library</p>
<p class="AB">CNT	Companions to the New Testament</p>
<p class="AB"><em class="italic">DRev</em> <em class="italic"> Downside Review</em></p>
<p class="AB">FCNT	Feminist Companion to the New Testament and Early Christian Writings</p>
<p class="AB">GNS	Good News Studies</p>
<p class="AB">ICC	International Critical Commentary</p>
<p class="AB">IFT	Introductions in Feminist Theology</p>
<p class="AB"><em class="italic">Int</em> <em class="italic">Interpretation</em></p>
<p class="AB"><em class="italic">JBL</em> <em class="italic">Journal of Biblical Literature</em></p>
<p class="AB"><em class="italic">J.W.</em>	Josephus, <em class="italic">Jewish War</em></p>
<p class="AB">KJV	King James Version</p>
<p class="AB">NAB	New American Bible</p>
<p class="AB">NASB	New American Standard Bible</p>
<p class="AB">NEB	New English Bible</p>
<p class="AB">NJB	New Jerusalem Bible</p>
<p class="AB">NRSV	New Revised Standard Version</p>
<p class="AB"><em class="italic">NTR</em> <em class="italic">New Theology Review</em></p>
<p class="AB">OBT	Overtures to Biblical Theology</p>
<p class="AB">OECS	Oxford Early Christian Studies</p>
<p class="AB">PG	Migne, <em class="italic">Patrologia Graeca</em></p>
<p class="AB">PTMS	Princeton Theological Monograph Series</p>
<p class="AB">SBLSymS	Society of Biblical Literature Symposium Series</p>
<p class="AB">SVC	Supplements to Vigiliae Christianae</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Reid_Wisdoms_Feast-5.vue?2d80c0ac